import {Component, Object3D, RetainEmitter} from '@wonderlandengine/api';
import {CustomLogTag} from '../classes/Constants.js';
import {WLUtils} from '../utils/WLUtils.js';

export class BlobPrefabs extends Component {
    static TypeName = 'blob-prefabs';

    // Singleton
    private static _instance: BlobPrefabs;
    static get instance(): BlobPrefabs {
        return BlobPrefabs._instance;
    }
    blobPrefabs!: Object3D;
    onPrefabsLoaded = new RetainEmitter<[Object3D]>();

    private _isLoaded = false;
    get isLoaded() {
        return this._isLoaded;
    }

    init(): void {
        BlobPrefabs._instance = this;
    }

    async start() {
        const s = await this.engine.loadPrefab('Pieces.bin');
        const r = this.engine.scene.instantiate(s);

        this.blobPrefabs = r.root;
        this.blobPrefabs.parent = this.object;
        this._isLoaded = true;
        setTimeout(() => this.onPrefabsLoaded.notify(this.blobPrefabs), 0);
    }

    /**
     * Spawns a piece with the given name
     * @param name Name of the piece to spawn
     * @param parent Optional parent object of the piece
     * @param startActive Optional boolean to set the active state of the piece; default is true
     * @returns The spawned piece object or null if spawn failed
     */
    spawn(name: string, parent: Object3D | null = null, startActive = true) {
        if (!this.blobPrefabs) {
            this.engine.log.warn(
                CustomLogTag.Game,
                `Spawning piece Failed. Piece Prefabs not loaded`
            );
            return null;
        }

        const piece = this.blobPrefabs.findByName(name)[0];

        if (!piece) {
            this.engine.log.warn(
                CustomLogTag.Game,
                `Spawning Piece Failed. Piece with name ${name} not found`
            );
            return null;
        }

        const clonedPiece = piece.clone(parent);
        //const clonedPiece = WLUtils.clone(piece, parent);

        // this.engine.log.info(CustomLogTag.Game, `Spawned Piece '${name}'`);

        if (startActive) {
            WLUtils.setActive(clonedPiece, true);
        }

        clonedPiece.resetPositionRotation();
        return clonedPiece;
    }
}
